import React from "react";
import FeedbackIndex from "./Index";
import CourseReviewIndex from "./CourseReviewIndex";

const FeedbacksPage = () => {
  return (
    <div>
      <h1>Feedbacks Page</h1>
      <div className="columns">
        <div className="column is-4">
          <FeedbackIndex isPageMode />
        </div>
        <div className="column is-4">
          <CourseReviewIndex isPageMode />
        </div>
      </div>
    </div>
  );
};

export default FeedbacksPage;
